"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SALES_CHANNEL = exports.PRODUCT_BUYING_PROGRAM = exports.PRODUCT_APPLICABLE_OFFER_TYPE = exports.LICENSE_QUANTITY_STATUS = exports.FULFILLABLE_ITEM_TYPE = exports.FULFILLABLE_ITEM_CONSTANTS = exports.CUSTOMER_SEGMENT = exports.hasTeamProducts = exports.hasSupportRoleAssignmentAllowed = exports.hasSupportCaseCreationAllowed = exports.hasSomeFulfillableItems = exports.hasProductSupportRoleAssignmentAllowed = exports.hasProductsInCloud = exports.hasOnlyTeamProducts = exports.hasEnterpriseProducts = exports.hasAllFulfillableItems = exports.getSupportFulfillableItems = exports.getSupportedProducts = exports.getProductById = exports.findFulfillableItem = exports.useProductList = exports.Product = exports.LicenseQuantityList = exports.toProductArray = exports.useLicenseGroupList = exports.LicenseGroup = exports.FulfillableItemList = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

var FulfillableItemList_1 = require("./FulfillableItemList");

Object.defineProperty(exports, "FulfillableItemList", {
  enumerable: true,
  get: function () {
    return FulfillableItemList_1.FulfillableItemList;
  }
});

var LicenseGroup_1 = require("./LicenseGroup");

Object.defineProperty(exports, "LicenseGroup", {
  enumerable: true,
  get: function () {
    return LicenseGroup_1.LicenseGroup;
  }
});

var LicenseGroupList_hook_1 = require("./LicenseGroupList-hook");

Object.defineProperty(exports, "useLicenseGroupList", {
  enumerable: true,
  get: function () {
    return LicenseGroupList_hook_1.useLicenseGroupList;
  }
});

var licenseGroupUtils_1 = require("./licenseGroupUtils");

Object.defineProperty(exports, "toProductArray", {
  enumerable: true,
  get: function () {
    return licenseGroupUtils_1.toProductArray;
  }
});

var LicenseQuantityList_1 = require("./LicenseQuantityList");

Object.defineProperty(exports, "LicenseQuantityList", {
  enumerable: true,
  get: function () {
    return LicenseQuantityList_1.LicenseQuantityList;
  }
});

var Product_1 = require("./Product");

Object.defineProperty(exports, "Product", {
  enumerable: true,
  get: function () {
    return Product_1.Product;
  }
});

var ProductList_hook_1 = require("./ProductList-hook");

Object.defineProperty(exports, "useProductList", {
  enumerable: true,
  get: function () {
    return ProductList_hook_1.useProductList;
  }
});

var productListUtils_1 = require("./productListUtils");

Object.defineProperty(exports, "findFulfillableItem", {
  enumerable: true,
  get: function () {
    return productListUtils_1.findFulfillableItem;
  }
});
Object.defineProperty(exports, "getProductById", {
  enumerable: true,
  get: function () {
    return productListUtils_1.getProductById;
  }
});
Object.defineProperty(exports, "getSupportedProducts", {
  enumerable: true,
  get: function () {
    return productListUtils_1.getSupportedProducts;
  }
});
Object.defineProperty(exports, "getSupportFulfillableItems", {
  enumerable: true,
  get: function () {
    return productListUtils_1.getSupportFulfillableItems;
  }
});
Object.defineProperty(exports, "hasAllFulfillableItems", {
  enumerable: true,
  get: function () {
    return productListUtils_1.hasAllFulfillableItems;
  }
});
Object.defineProperty(exports, "hasEnterpriseProducts", {
  enumerable: true,
  get: function () {
    return productListUtils_1.hasEnterpriseProducts;
  }
});
Object.defineProperty(exports, "hasOnlyTeamProducts", {
  enumerable: true,
  get: function () {
    return productListUtils_1.hasOnlyTeamProducts;
  }
});
Object.defineProperty(exports, "hasProductsInCloud", {
  enumerable: true,
  get: function () {
    return productListUtils_1.hasProductsInCloud;
  }
});
Object.defineProperty(exports, "hasProductSupportRoleAssignmentAllowed", {
  enumerable: true,
  get: function () {
    return productListUtils_1.hasProductSupportRoleAssignmentAllowed;
  }
});
Object.defineProperty(exports, "hasSomeFulfillableItems", {
  enumerable: true,
  get: function () {
    return productListUtils_1.hasSomeFulfillableItems;
  }
});
Object.defineProperty(exports, "hasSupportCaseCreationAllowed", {
  enumerable: true,
  get: function () {
    return productListUtils_1.hasSupportCaseCreationAllowed;
  }
});
Object.defineProperty(exports, "hasSupportRoleAssignmentAllowed", {
  enumerable: true,
  get: function () {
    return productListUtils_1.hasSupportRoleAssignmentAllowed;
  }
});
Object.defineProperty(exports, "hasTeamProducts", {
  enumerable: true,
  get: function () {
    return productListUtils_1.hasTeamProducts;
  }
});

var types_1 = require("./types");

Object.defineProperty(exports, "CUSTOMER_SEGMENT", {
  enumerable: true,
  get: function () {
    return types_1.CUSTOMER_SEGMENT;
  }
});
Object.defineProperty(exports, "FULFILLABLE_ITEM_CONSTANTS", {
  enumerable: true,
  get: function () {
    return types_1.FULFILLABLE_ITEM_CONSTANTS;
  }
});
Object.defineProperty(exports, "FULFILLABLE_ITEM_TYPE", {
  enumerable: true,
  get: function () {
    return types_1.FULFILLABLE_ITEM_TYPE;
  }
});
Object.defineProperty(exports, "LICENSE_QUANTITY_STATUS", {
  enumerable: true,
  get: function () {
    return types_1.LICENSE_QUANTITY_STATUS;
  }
});
Object.defineProperty(exports, "PRODUCT_APPLICABLE_OFFER_TYPE", {
  enumerable: true,
  get: function () {
    return types_1.PRODUCT_APPLICABLE_OFFER_TYPE;
  }
});
Object.defineProperty(exports, "PRODUCT_BUYING_PROGRAM", {
  enumerable: true,
  get: function () {
    return types_1.PRODUCT_BUYING_PROGRAM;
  }
});
Object.defineProperty(exports, "SALES_CHANNEL", {
  enumerable: true,
  get: function () {
    return types_1.SALES_CHANNEL;
  }
});